// extracted by mini-css-extract-plugin
module.exports = {"menuItem":"MenuItem_menuItem__22Hzp","current":"MenuItem_current__1i7vJ"};